// QuillConfig.js

export const getFullEditorModules = (
  quillInstanceRef,
  openHtmlDialog,
  openImageUrlDialog,
  handleImageUpload,
  // ⬇️ new options bag (keeps existing call sites working)
  { allowImages = true } = {}
) => {
  // base toolbar rows
  const container = [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ script: 'sub' }, { script: 'super' }],
    ['blockquote', 'code-block'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    [{ align: [] }],
    ['clean'],
    ['link'],
    // last row is conditional
    allowImages ? ['image', 'insertImageUrl', 'html'] : ['html'],
  ]

  const handlers = {
    html: openHtmlDialog,
    ...(allowImages
      ? { image: handleImageUpload, insertImageUrl: openImageUrlDialog }
      : {}), // no-op: no handler when images disabled
  }

  const modules = {
    toolbar: { container, handlers },
    ...(allowImages ? { blotFormatter2: {} } : {}), // drop image formatter when disallowed
  }

  return modules
}
